import { createSelector, createSlice } from '@reduxjs/toolkit';
import { sortItems } from '@utils/functions.js';

const initialState = {
  isLoading: false,
  isActive: false,
  id: 0,
  uid: 0,
  sid: 0,

  blockContent: {
    items: [],
    heading: {
      title: '',
      description: '',
      textAlign: 'left',
      image: '',
      divider: '',
      position: '',
    },
  },
  blockDesign: {
    layout: 'cover',
    view: 'multi',
    heightType: 'square',
  },
  containerDesign: {},
  itemDesign: {},
};

export const sliderSlice = createSlice({
  name: 'slider',
  initialState,
  reducers: {
    sliderStore: (state, action) => {
      const { id, isActive, sid, uid, data } = action.payload;

      const block = data ?? {};
      const { blockContent, blockDesign } = block;
      const { containerDesign, itemDesign } = blockDesign;

      state.isLoading = false;
      state.id = id ?? 0;
      state.isActive = isActive;
      state.sid = sid;
      state.uid = uid;

      state.containerDesign = containerDesign ?? {};
      state.itemDesign = itemDesign ?? {};

      state.blockContent = {
        items: blockContent.items ?? [],
        heading: {
          title: blockContent.heading.title ?? '',
          description: blockContent.heading.description ?? '',
          textAlign: blockContent.heading.textAlign ?? 'left',
          image: blockContent.heading.image ?? '',
          divider: blockContent.heading.divider ?? '',
          position: blockContent.heading.position ?? '',
        },
      };

      state.blockDesign = {
        layout: blockDesign.layout ?? 'cover',
        view: blockDesign.view ?? 'multi',
        heightType: blockDesign.heightType ?? 'square',
      };
    },
    sliderClear: () => initialState,

    sliderUpdateIsLoading: (state, action) => {
      state.isLoading = action.payload;
    },
    sliderUpdateIsActive: (state, action) => {
      state.isActive = action.payload;
    },
    sliderUpdateBlockContent: (state, action) => {
      state.blockContent = action.payload;
    },
    sliderUpdateBlockDesign: (state, action) => {
      state.blockDesign = action.payload;
    },
  },
});

export const { sliderStore, sliderClear, sliderUpdateIsLoading, sliderUpdateIsActive, sliderUpdateBlockContent, sliderUpdateBlockDesign } = sliderSlice.actions;

export const selectSliderIsLoading = (state) => state.slider.isLoading;

export const selectSliderId = (state) => state.slider.id;
export const selectSliderUID = (state) => state.slider.uid;
export const selectSliderSID = (state) => state.slider.sid;

export const selectSliderBlockContent = (state) => state.slider.blockContent;
export const selectSliderBlockDesign = (state) => state.slider.blockDesign;
export const selectSliderSortItems = createSelector([selectSliderBlockContent], ({ items }) => {
  return sortItems(items);
});
export const selectSliderContainerDesign = (state) => state.slider.containerDesign;
export const selectSliderItemDesign = (state) => state.slider.itemDesign;

export default sliderSlice.reducer;
